import g from '#core/global';
import load from '#core/load';
import pattern_config from '#core/pattern-config';
import expandable from '#partial/expandable/expandable';


const spotlight_scroll_trigger_$ = '[data-spotlight-hero-scroll]';
const spotlight_hero_$ = '.spotlight-hero';
const hero_wrapper_$ = '.hero-wrapper';
const masthead_$ = '.masthead';

let has_scroll_cue_events = false;


// Mobile-expandable / desktop-always-visible toggle for the hero footer
// (jump nav, etc.). Generic behavior lives in expandable.responsive() —
// reusable for any region with the same UX requirement.
expandable.responsive({
	id: 'hero',
	selector: '[data-hero-footer] .expandable-button--hero',
	breakpoint: pattern_config.hero.layout_switch,
});


load.content(() => {
	assign_scroll_cue_events();
});


function assign_scroll_cue_events() {
	if (has_scroll_cue_events) return;
	has_scroll_cue_events = true;

	document.addEventListener(g.click_e, e => {
		if (!(e.target instanceof Element)) return;

		const $trigger = e.target.closest(spotlight_scroll_trigger_$);
		if (!$trigger) return;

		e.preventDefault();
		scroll_to_next_section($trigger);
	});
}


function scroll_to_next_section($trigger) {
	const $hero = $trigger.closest(spotlight_hero_$);
	const $hero_wrapper = $hero?.closest(hero_wrapper_$);
	const $target = get_scroll_target($hero_wrapper);

	if (!$target) return;

	const masthead_height = get_masthead_height();
	const target_top = $target.getBoundingClientRect().top + window.scrollY - masthead_height;
	const reduced_motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	window.scrollTo({
		top: Math.max(0, target_top),
		behavior: reduced_motion ? 'auto' : 'smooth',
	});
}


function get_scroll_target($hero_wrapper) {
	if (!$hero_wrapper) return null;

	const $next = $hero_wrapper.nextElementSibling;
	if (!$next) return null;

	if ('main' !== $next.tagName.toLowerCase()) return $next;

	return Array.from($next.children).find($child => {
		return $child.offsetParent !== null;
	}) || $next;
}


function get_masthead_height() {
	const $masthead = document.querySelector(masthead_$);
	if (!$masthead) return 0;

	return $masthead.getBoundingClientRect().height;
}
